var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 10.9905C9.5625 11.6369 9.81931 12.2569 10.2764 12.714C10.7335 13.1712 11.3535 13.428 12 13.428C12.6465 13.428 13.2665 13.1712 13.7236 12.714C14.1807 12.2569 14.4375 11.6369 14.4375 10.9905C14.4375 10.344 14.1807 9.72402 13.7236 9.2669C13.2665 8.80979 12.6465 8.55298 12 8.55298C11.3535 8.55298 10.7335 8.80979 10.2764 9.2669C9.81931 9.72402 9.5625 10.344 9.5625 10.9905Z",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5963 15.5865L13.1489 19.034C12.8442 19.3384 12.4311 19.5094 12.0004 19.5094C11.5697 19.5094 11.1566 19.3384 10.8519 19.034L7.40369 15.5865C6.49468 14.6775 5.87565 13.5193 5.62487 12.2584C5.3741 10.9976 5.50284 9.69066 5.99482 8.50296C6.4868 7.31526 7.31992 6.30012 8.38883 5.5859C9.45774 4.87169 10.7144 4.49048 12 4.49048C13.2856 4.49048 14.5423 4.87169 15.6112 5.5859C16.6801 6.30012 17.5132 7.31526 18.0052 8.50296C18.4972 9.69066 18.6259 10.9976 18.3751 12.2584C18.1243 13.5193 17.5053 14.6775 16.5963 15.5865Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBased);
export default __webpack_public_path__ + "static/media/LocationBased.ae16c70f035f4debf13cde5da7db3a86.svg";
export { ForwardRef as ReactComponent };